import React, { useState, useEffect, useRef } from 'react';
import { auth, db } from '../../firebase';
import { doc, setDoc, getDoc, updateDoc } from 'firebase/firestore';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import correctSoundFile from '../../assets/correct.mp3';
import wrongSoundFile from '../../assets/wrong.mp3';
import Navbar from '../../components/Navbar';
import { useWindowSize } from '@uidotdev/usehooks';
import './SynonymSync.css';


// Word list remains unchanged
// Expanded word list with difficulty levels (80 entries)
const words = [
  // Easy
  { word: 'Happy', correct: 'Joyful', options: ['Joyful','Sad','Angry'], diff:'easy' },
  { word: 'Fast', correct: 'Rapid', options: ['Slow','Rapid','Late'], diff:'easy' },
  { word: 'Quiet', correct: 'Silent', options: ['Loud','Noisy','Silent'], diff:'easy' },
  { word: 'Bright', correct: 'Radiant', options: ['Dull','Gloomy','Radiant'], diff:'easy' },
  { word: 'Lucky', correct: 'Fortunate', options: ['Unlucky','Cursed','Fortunate'], diff:'easy' },
  { word: 'Clean', correct: 'Pristine', options: ['Dirty','Messy','Pristine'], diff:'easy' },
  { word: 'Weak', correct: 'Feeble', options: ['Strong','Robust','Feeble'], diff:'easy' },
  { word: 'Soft', correct: 'Gentle', options: ['Harsh','Rough','Gentle'], diff:'easy' },
  { word: 'Sure', correct: 'Certain', options: ['Doubtful','Unsure','Certain'], diff:'easy' },
  { word: 'Full', correct: 'Complete', options: ['Partial','Incomplete','Complete'], diff:'easy' },

  // Medium
  { word: 'Begin', correct: 'Commence', options: ['End','Finish','Commence'], diff:'medium' },
  { word: 'Calm', correct: 'Tranquil', options: ['Angry','Restless','Tranquil'], diff:'medium' },
  { word: 'Kind', correct: 'Benevolent', options: ['Cruel','Mean','Benevolent'], diff:'medium' },
  { word: 'Short', correct: 'Brief', options: ['Long','Extended','Brief'], diff:'medium' },
  { word: 'Greet', correct: 'Salute', options: ['Ignore','Dismiss','Salute'], diff:'medium' },
  { word: 'Strong', correct: 'Robust', options: ['Fragile','Weak','Robust'], diff:'medium' },
  { word: 'Angry', correct: 'Irate', options: ['Calm','Happy','Irate'], diff:'medium' },
  { word: 'Big', correct: 'Enormous', options: ['Tiny','Little','Enormous'], diff:'medium' },
  { word: 'Correct', correct: 'Accurate', options: ['Wrong','False','Accurate'], diff:'medium' },
  { word: 'Hide', correct: 'Conceal', options: ['Reveal','Show','Conceal'], diff:'medium' },
  { word: 'Speak', correct: 'Utter', options: ['Listen','Hear','Utter'], diff:'medium' },
  { word: 'Help', correct: 'Assist', options: ['Hinder','Obstruct','Assist'], diff:'medium' },
  { word: 'Join', correct: 'Unite', options: ['Separate','Divide','Unite'], diff:'medium' },
  { word: 'Lead', correct: 'Guide', options: ['Follow','Trail','Guide'], diff:'medium' },
  { word: 'Grow', correct: 'Expand', options: ['Shrink','Contract','Expand'], diff:'medium' },
  { word: 'Trust', correct: 'Believe', options: ['Doubt','Distrust','Believe'], diff:'medium' },
  { word: 'Move', correct: 'Proceed', options: ['Stop','Halt','Proceed'], diff:'medium' },
  { word: 'Think', correct: 'Ponder', options: ['Ignore','Forget','Ponder'], diff:'medium' },
  { word: 'Fight', correct: 'Struggle', options: ['Surrender','Yield','Struggle'], diff:'medium' },
  { word: 'Teach', correct: 'Instruct', options: ['Mislead','Confuse','Instruct'], diff:'medium' },

  // Hard
  { word: 'End', correct: 'Terminate', options: ['Start','Begin','Terminate'], diff:'hard' },
  { word: 'Obtain', correct: 'Acquire', options: ['Lose','Give','Acquire'], diff:'hard' },
  { word: 'Complex', correct: 'Intricate', options: ['Simple','Plain','Intricate'], diff:'hard' },
  { word: 'Bold', correct: 'Audacious', options: ['Timid','Bashful','Audacious'], diff:'hard' },
  { word: 'Quick', correct: 'Expeditious', options: ['Sluggish','Leisurely','Expeditious'], diff:'hard' },
  { word: 'Silent', correct: 'Taciturn', options: ['Talkative','Garrulous','Taciturn'], diff:'hard' },
  { word: 'Smart', correct: 'Astute', options: ['Dull','Dense','Astute'], diff:'hard' },
  { word: 'Learn', correct: 'Assimilate', options: ['Forget','Ignore','Assimilate'], diff:'hard' },
  { word: 'Famous', correct: 'Renowned', options: ['Unknown','Obscure','Renowned'], diff:'hard' },
  { word: 'Wealthy', correct: 'Affluent', options: ['Poor','Needy','Affluent'], diff:'hard' },
  { word: 'Cautious', correct: 'Prudent', options: ['Reckless','Careless','Prudent'], diff:'hard' },
  { word: 'Help', correct: 'Facilitate', options: ['Hinder','Block','Facilitate'], diff:'hard' },
  { word: 'Decline', correct: 'Refuse', options: ['Accept','Agree','Refuse'], diff:'hard' },
  { word: 'Distant', correct: 'Remote', options: ['Nearby','Close','Remote'], diff:'hard' },
  { word: 'Eager', correct: 'Keen', options: ['Reluctant','Hesitant','Keen'], diff:'hard' },
  { word: 'Fragile', correct: 'Delicate', options: ['Strong','Sturdy','Delicate'], diff:'hard' },
  { word: 'Grateful', correct: 'Thankful', options: ['Ungrateful','Heedless','Thankful'], diff:'hard' },
  { word: 'Harsh', correct: 'Severe', options: ['Gentle','Mild','Severe'], diff:'hard' },
  { word: 'Isolate', correct: 'Sequester', options: ['Join','Unite','Sequester'], diff:'hard' },
  { word: 'Justice', correct: 'Equity', options: ['Bias','Prejudice','Equity'], diff:'hard' },
  { word: 'Knowledge', correct: 'Erudition', options: ['Ignorance','Naivety','Erudition'], diff:'hard' },
  { word: 'Liberate', correct: 'Emancipate', options: ['Oppress','Enslave','Emancipate'], diff:'hard' },
  { word: 'Meticulous', correct: 'Scrupulous', options: ['Careless','Sloppy','Scrupulous'], diff:'hard' },
  { word: 'Negotiate', correct: 'Bargain', options: ['Demand','Command','Bargain'], diff:'hard' },
  { word: 'Obliterate', correct: 'Eradicate', options: ['Create','Build','Eradicate'], diff:'hard' },
  { word: 'Perilous', correct: 'Dangerous', options: ['Safe','Secure','Dangerous'], diff:'hard' },
  { word: 'Rebel', correct: 'Mutiny', options: ['Obey','Comply','Mutiny'], diff:'hard' },
  { word: 'Submerge', correct: 'Immerse', options: ['Emerge','Surface','Immerse'], diff:'hard' },
  { word: 'Tepid', correct: 'Lukewarm', options: ['Hot','Cold','Lukewarm'], diff:'hard' },
  { word: 'Ubiquitous', correct: 'Omnipresent', options: ['Rare','Scarce','Omnipresent'], diff:'hard' },
  { word: 'Vacillate', correct: 'Waver', options: ['Decide','Resolve','Waver'], diff:'hard' },
  { word: 'Wary', correct: 'Cautious', options: ['Reckless','Careless','Cautious'], diff:'hard' }
];
export default function SynonymSync() {
  const navigate = useNavigate();
  const correctSound = useRef(new Audio(correctSoundFile));
  const wrongSound = useRef(new Audio(wrongSoundFile));
  const { width, height } = useWindowSize();

  const [accessType, setAccessType] = useState('demo');
  const [difficulty, setDifficulty] = useState('easy');
  const [currentWord, setCurrentWord] = useState(null);
  const [chronos, setChronos] = useState(0);
  const [choices, setChoices] = useState([]);
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [message, setMessage] = useState('');
  const [timeLeft, setTimeLeft] = useState(5);
  const [progress, setProgress] = useState(100);
  const [gameOver, setGameOver] = useState(false);
  const [dailyPlays, setDailyPlays] = useState(0);
  const [maxPlays, setMaxPlays] = useState(25);
  const [limitReached, setLimitReached] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [comboCount, setComboCount] = useState(0);
  const [comboMessage, setComboMessage] = useState('');
  const [shake, setShake] = useState(false);
  const [correctCount, setCorrectCount] = useState(0);

  // Adjust difficulty as correctCount increases
  useEffect(() => {
    if (correctCount >= 6) setDifficulty('hard');
    else if (correctCount >= 3) setDifficulty('medium');
    else setDifficulty('easy');
  }, [correctCount]);

  // Load initial user stats
  useEffect(() => {
    const init = async () => {
      if (!auth.currentUser) return;
      const userRef = doc(db, 'users', auth.currentUser.uid);
      const snap = await getDoc(userRef);
      if (!snap.exists()) return;
      const data = snap.data();

      if (!data.isActive) {
        toast.error('Profile deactivated. Contact support.');
        return navigate('/contact');
      }
      const limit = data.accessType === 'pro' ? 200 : 25;
      setAccessType(data.accessType);
      setMaxPlays(limit);
      if (data.accessType === 'demo' && data.accessExpiry && new Date() > new Date(data.accessExpiry)) {
        toast.error('Demo expired. Please upgrade.');
        setLimitReached(true);
        return;
      }

      const today = new Date().toDateString();
      let plays = data.synonymPlaysDate === today ? data.synonymPlays || 0 : 0;
      if (data.synonymPlaysDate !== today) {
        await updateDoc(userRef, { synonymPlays: 0, synonymPlaysDate: today });
      }
      setDailyPlays(plays);
      if (plays >= limit) setLimitReached(true);

      setChronos(data.chronos || 0);
      initQuestion();
    };
    init();
  }, [navigate]);

  // Countdown timer
  useEffect(() => {
    if (gameOver || limitReached) return;
    if (timeLeft <= 0) {
      setGameOver(true);
      setMessage("⏰ Time's up! Game Over.");
      wrongSound.current.play();
      updateLeaderboardSynonym(correctCount);
      return;
    }
    const tm = setTimeout(() => setTimeLeft(t => t - 1), 1000);
    return () => clearTimeout(tm);
  }, [timeLeft, gameOver, limitReached]);

  // Progress bar
  useEffect(() => {
    if (gameOver || limitReached) return;
    const iv = setInterval(() => {
      setProgress(p => Math.max(0, p - (100 / (5 * 10))));
    }, 100);
    return () => clearInterval(iv);
  }, [gameOver, limitReached]);

  // Choose next question
  const initQuestion = () => {
    const pool = words.filter(w => w.diff === difficulty);
    const word = pool[Math.floor(Math.random() * pool.length)];
    const others = pool.filter(w => w.word !== word.word);
    const distract = [];
    while (distract.length < 3 && others.length) {
      const i = Math.floor(Math.random() * others.length);
      distract.push(others.splice(i,1)[0].correct);
    }
    setCurrentWord(word);
    setChoices([...distract, word.correct].sort(() => Math.random() - .5));
    setTimeLeft(5);
    setProgress(100);
  };

  // Leaderboard update
  async function updateLeaderboardSynonym(correctWords) {
    if (!auth.currentUser) return;
    const userSnap = await getDoc(doc(db, 'users', auth.currentUser.uid));
    let playerName = 'Brainy Player';
    if (userSnap.exists()) {
      const d = userSnap.data();
      playerName = d.name || auth.currentUser.displayName || playerName;
    }
    const lbRef = doc(db, 'leaderboard_master', auth.currentUser.uid);
    const lbSnap = await getDoc(lbRef);
    const today = new Date().toDateString();
    const record = {
      name: playerName,
      chronos,
      bestNumberMemoryLevel: 0,
      bestFocusGameStreak: 0,
      bestSynonymWords: correctWords,
      lastPlayed: today
    };
    if (lbSnap.exists()) {
      const prev = lbSnap.data();
      record.bestNumberMemoryLevel = prev.bestNumberMemoryLevel || 0;
      record.bestFocusGameStreak = prev.bestFocusGameStreak || 0;
      record.bestSynonymWords = Math.max(prev.bestSynonymWords || 0, correctWords);
      await setDoc(lbRef, record, { merge: true });
    } else {
      await setDoc(lbRef, record);
    }
  }

  // Handle answer
  const handleAnswer = async (opt) => {
    if (gameOver || limitReached) return;
    setSelectedChoice(opt);
    const userRef = doc(db, 'users', auth.currentUser.uid);
    const snap = await getDoc(userRef);
    if (!snap.exists()) return;
    const data = snap.data();

    const today = new Date().toDateString();
    const plays = (data.synonymPlaysDate === today ? data.synonymPlays : 0) + 1;
    if (plays === maxPlays - 5) toast("⚠️ Only 5 plays left today.");
    await updateDoc(userRef, { synonymPlays: plays, synonymPlaysDate: today });
    setDailyPlays(plays);
    if (plays >= maxPlays) {
      setLimitReached(true);
      toast.error('Daily limit reached. Upgrade for more plays.');
      return;
    }

    if (opt === currentWord.correct) {
      correctSound.current.play();
      const bonus = comboCount >= 10 ? 5 : comboCount >= 5 ? 3 : comboCount >= 3 ? 2 : 1;
      const newChronos = (data.chronos || 0) + bonus;
      setChronos(newChronos);
      await updateDoc(userRef, { chronos: newChronos });

      const nextCount = correctCount + 1;
      setCorrectCount(nextCount);
      if ([10,20,30].includes(nextCount)) {
        setShowConfetti(true);
        setTimeout(() => setShowConfetti(false), 3000);
      }
      const newCombo = comboCount + 1;
      setComboCount(newCombo);
      if (newCombo === 3) setComboMessage('🔥 Combo x2!');
      else if (newCombo === 5) setComboMessage('💎 Mega Combo x3!');
      else if (newCombo === 10) setComboMessage('🚀 Ultra Combo x5!');
      else if (newCombo > 10) setComboMessage(`🔥 x${newCombo}!`);
      else setComboMessage(''); 

      updateLeaderboardSynonym(nextCount);
      setMessage('✅ Correct!');
      initQuestion();
      setSelectedChoice(null);
    } else {
      wrongSound.current.play();
      setShake(true);
      setMessage('❌ Wrong! Try again.');
      updateLeaderboardSynonym(correctCount);
      setTimeout(() => {
        setShake(false);
        setGameOver(true);
      }, 500);
    }
  };

  // Play again
  const handlePlayAgain = () => {
    if (limitReached && accessType === 'demo') return navigate('/upgrade');
    if (limitReached && accessType === 'pro') {
      toast("🎯 You've completed your daily goal. Come back tomorrow for more!");
      return;
    }
    setGameOver(false);
    setSelectedChoice(null);
    setComboCount(0);
    setMessage('');
    initQuestion();
  };

  return (
    <>
      <Navbar />
      <Toaster position="top-center" containerStyle={{pointerEvents:'none'}} toastOptions={{style:{pointerEvents:'auto'}}}/>
      {showConfetti && <Confetti width={width} height={height}/>}      
      <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-tr from-yellow-100 via-white to-purple-100">
        <h1 className="text-3xl font-bold text-purple-800 mb-2">📚 Synonym Sync</h1>
        <div className="w-11/12 max-w-md bg-gray-300 border border-purple-400 rounded-full h-6 mb-6 overflow-hidden shadow-md">
          <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 h-full transition-all duration-100 ease-linear" style={{width:`${progress}%`}}/>
        </div>
        <p className="text-sm text-gray-600 mb-2">Difficulty: {difficulty.toUpperCase()} ⏳ {timeLeft}s</p>
        {!gameOver && !limitReached ? (
          <>
            <p className="text-lg mb-2 text-gray-700">Find synonym of:</p>
            <div className={`text-2xl font-semibold text-purple-600 mb-6 ${shake?'shake':''}`}>{currentWord?.word}</div>
            <div className="grid grid-cols-2 gap-4 mb-4">{
              choices.map((opt,i)=>(
                <button key={i} onClick={()=>handleAnswer(opt)} disabled={gameOver||limitReached}
                  className={`px-6 py-3 rounded-lg text-lg font-medium shadow transition-transform duration-150 ease-in-out ${selectedChoice===opt?(opt===currentWord?.correct?'bg-green-500 scale-105':'bg-red-500 shake'):'bg-purple-500 hover:bg-purple-600'} text-white disabled:opacity-50 disabled:cursor-not-allowed`}
                >{opt}</button>
              ))}
            </div>
          </>
        ) : (
          <>
            <div className="text-xl font-medium mb-4 text-center text-purple-700">{message}</div>
            {limitReached ? (
              accessType === 'demo' ? (
                <>
                  <div className="text-center text-lg font-semibold text-red-600 mb-4">
                    🎓 You've reached your daily demo limit.<br />Upgrade to Pro for unlimited plays!
                  </div>
                  <button
                    onClick={() => navigate('/upgrade')}
                    className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-lg shadow"
                  >
                    🚀 Upgrade to Pro
                  </button>
                </>
              ) : (
                <div className="text-center text-lg font-semibold text-green-700 mb-4">
                  🌟 Great job today! Come back tomorrow for more learning!
                </div>
              )
            ) : (
              <button
                onClick={handlePlayAgain}
                className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg text-lg shadow"
              >
                🔁 Play Again
              </button>
            )}
          </>
        )}
        <p className="mt-6 text-sm text-purple-700 font-semibold">Chronos: {chronos} ⏳</p>
        {comboMessage && <div className="text-lg text-orange-600 font-bold mt-2 animate-bounce">{comboMessage}</div>}
      </div>
      <style jsx>{`...`}</style>
    </>
  );
  }
  
